var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step"},[(_vm.showCode)?_c('div',{staticClass:"point_list"},_vm._l((_vm.slotlist),function(item,index){return _c('div',{key:index,staticClass:"point_item"},[_c('div',{class:['point',_vm.step == index ? 'point_active' : '']},[_vm._v(_vm._s(index + 1))])])}),0):_vm._e(),_vm._l((_vm.slotlist),function(item,index){return _c('div',{key:index,class:[
        'step_item',
        _vm.step == index ? 'show' : '',
        _vm.step != index ? 'hidden' : ''
    ]},[_vm._t(item)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }